// Componentes da página de produto da Body (carregado só em templates de produto).
// A troca de variante é do Horizon; aqui só se acompanha pelo evento productSelect.
import { StandardEvents } from '@shopify/events';

export function aoTrocarVariante(el, fn) {
  const secao = el.closest('.shopify-section');
  if (!secao) return;
  secao.addEventListener(StandardEvents.productSelect, (e) => {
    e.promise?.then(({ detail }) => fn(detail?.resource ?? null)).catch(() => {});
  });
}

class BodySabores extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ligado) return;
    this.dataset.ligado = '1';
    this.addEventListener('click', (e) => {
      const mais = e.target.closest('[data-body-sabores-mais]');
      if (mais) {
        this.querySelectorAll('.body-sabor[hidden]').forEach((b) => { b.hidden = false; });
        mais.remove();
        return;
      }
      const b = e.target.closest('.body-sabor');
      if (!b) return;
      this.marcar(b);
      const radio = this.closest('.shopify-section')?.querySelector(`variant-picker input[data-option-value-id="${b.dataset.optionValueId}"]`);
      if (radio && !radio.checked) radio.click();
    });
  }

  marcar(b) {
    this.querySelectorAll('.body-sabor').forEach((x) => {
      x.classList.toggle('is-ativo', x === b);
      x.setAttribute('aria-checked', String(x === b));
    });
    const atual = this.querySelector('[data-body-sabor-atual]');
    if (atual) atual.textContent = b.dataset.valor;
  }
}
if (!customElements.get('body-sabores')) customElements.define('body-sabores', BodySabores);

class BodyAviseMe extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ligado) return;
    this.dataset.ligado = '1';
    aoTrocarVariante(this, (v) => {
      this.hidden = !!(v && v.available);
      if (!v) return;
      const nome = this.dataset.produto + (v.title && v.title !== 'Default Title' ? ` (${v.title})` : '');
      const corpo = this.querySelector('[data-body-avise-corpo]');
      if (corpo) corpo.value = `Avise-me quando chegar: ${nome}`;
      const w = this.querySelector('[data-body-avise-whats]');
      if (w) w.href = 'https://wa.me/5575981896216?text=' + encodeURIComponent(`Olá! Vim pelo site da Body. Quero ser avisado quando chegar: ${nome}\n${this.dataset.link || location.href}`);
    });
  }
}
if (!customElements.get('body-avise-me')) customElements.define('body-avise-me', BodyAviseMe);

// Estoque baixo da campanha ("Restam só N") acompanha a variante escolhida.
document.querySelectorAll('[data-body-estoque]').forEach((el) => {
  let mapa = {};
  try { mapa = JSON.parse(el.dataset.mapa || '{}'); } catch { mapa = {}; }
  aoTrocarVariante(el, (v) => {
    const q = v ? mapa[v.id] || 0 : 0;
    el.hidden = q === 0;
    if (q) el.innerHTML = `Restam só <b>${q}</b><span class="body-campanha__un"> ${q === 1 ? 'unidade' : 'unidades'}</span>`;
  });
});

// Preço no PIX com o cupom da campanha acompanha a variante escolhida (mapa em centavos).
document.querySelectorAll('[data-body-cupom]').forEach((el) => {
  let mapa = {};
  try { mapa = JSON.parse(el.dataset.mapa || '{}'); } catch { mapa = {}; }
  const alvo = el.querySelector('[data-body-cupom-preco]');
  aoTrocarVariante(el, (v) => {
    const c = v ? mapa[v.id] : undefined;
    if (c && alvo) alvo.textContent = (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  });
});

// Kits no bloco de compra (blocks/body-kits.liquid).
// Modo "opcao": as variantes "Kits" do produto; aciona o seletor do Horizon.
// Modo "lista": kits que são produtos próprios. Escolher um troca o ID do formulário do
// Horizon pelo da variante do kit (mesmo sabor) e mostra o preço do kit na página e na
// barra fixa; "1 unidade" restaura. Com a configuração ligada, um seletor de sabor por pote.
class BodyKits extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ligado) return;
    this.dataset.ligado = '1';
    this.secao = this.closest('.shopify-section');
    this.addEventListener('click', (e) => {
      const l = e.target.closest('.body-kit');
      if (!l) return;
      if (l.getAttribute('aria-disabled') === 'true') {
        // Kit sem o sabor escolhido: troca para um sabor que o kit tem e escolhe o kit em seguida.
        if (this.dataset.modo === 'lista' && l.dataset.temSabor === 'true') this.trocarParaSaborDoKit(l);
        return;
      }
      if (this.dataset.modo === 'opcao') {
        this.marcar(l);
        const radio = this.secao?.querySelector(`variant-picker input[data-option-value-id="${l.dataset.optionValueId}"]`);
        if (radio && !radio.checked) radio.click();
        return;
      }
      this.escolher(l);
    });
    this.addEventListener('change', (e) => { if (e.target.matches('select[data-body-pote]')) this.gravarPotes(); });
    if (this.dataset.modo === 'lista') {
      this.guardarBase();
      aoTrocarVariante(this, () => setTimeout(() => this.aoTrocarSabor(), 0));
    }
  }

  get form() { return this.secao?.querySelector('product-form-component form'); }
  get idInput() { return this.secao?.querySelector('product-form-component input[name="id"]'); }
  // Preço da página e o da barra fixa do Horizon.
  get precos() { return [...(this.secao?.querySelectorAll('.body-preco--pagina') || [])]; }
  get escolhido() { return this.querySelector('.body-kit.is-ativo'); }

  marcar(l) {
    this.querySelectorAll('.body-kit').forEach((x) => {
      x.classList.toggle('is-ativo', x === l);
      x.setAttribute('aria-checked', String(x === l));
    });
  }

  guardarBase() {
    this.base = { preco: this.precos[0]?.innerHTML, id: this.idInput?.value };
  }

  saborAtual() {
    return (this.secao?.querySelector('[data-body-sabor-atual]')?.textContent || '').trim();
  }

  escolher(l) {
    this.marcar(l);
    if (l.dataset.kit === 'base') {
      if (this.base.preco) this.precos.forEach((p) => { p.innerHTML = this.base.preco; });
      if (this.idInput && this.base.id) this.idInput.value = this.base.id;
      this.montarPotes(null);
      return;
    }
    if (this.idInput) this.idInput.value = l.dataset.variante;
    const p = l.querySelector('.body-preco');
    if (p) this.precos.forEach((x) => { x.innerHTML = p.innerHTML; });
    this.montarPotes(l);
  }

  aoTrocarSabor() {
    // O Horizon acabou de trocar preço e ID para a nova variante do produto: isso é a nova base.
    this.guardarBase();
    const nome = this.saborAtual();
    const sabor = nome.toLowerCase();
    this.querySelectorAll('.body-kit[data-kit]:not([data-kit="base"])').forEach((l) => {
      if (l.dataset.temSabor !== 'true') return;
      const vs = JSON.parse(l.querySelector('[data-body-kit-variantes]').textContent);
      const v = vs.find((x) => x.sabor === sabor && x.available);
      l.dataset.variante = v ? v.id : '';
      l.setAttribute('aria-disabled', String(!v));
      l.querySelector('[data-body-kit-aviso]').textContent = v ? '' : `Sem ${nome} neste kit. Toque para trocar o sabor`;
    });
    const pendente = this.pendente;
    this.pendente = null;
    if (pendente && pendente.getAttribute('aria-disabled') === 'false') {
      this.escolher(pendente);
      return;
    }
    const atual = this.escolhido;
    if (!atual || atual.dataset.kit === 'base') return;
    if (atual.getAttribute('aria-disabled') === 'true') this.escolher(this.querySelector('.body-kit[data-kit="base"]'));
    else this.escolher(atual);
  }

  trocarParaSaborDoKit(l) {
    const vs = JSON.parse(l.querySelector('[data-body-kit-variantes]').textContent).filter((x) => x.available);
    const botoes = [...(this.secao?.querySelectorAll('.body-sabor:not(.is-esgotado)') || [])];
    const b = botoes.find((x) => vs.some((v) => v.sabor === x.dataset.valor.trim().toLowerCase()));
    if (!b) return;
    this.pendente = l;
    b.hidden = false;
    b.click();
  }

  montarPotes(l) {
    const caixa = this.querySelector('[data-body-potes]');
    const n = l ? Number(l.dataset.unidades || 1) : 0;
    const sabores = [...(this.secao?.querySelectorAll('.body-sabor') || [])].map((b) => ({ valor: b.dataset.valor, esgotado: b.classList.contains('is-esgotado') }));
    if (this.dataset.saboresPorPote !== 'true' || n < 2 || !sabores.length) {
      caixa.hidden = true;
      caixa.innerHTML = '';
      this.gravarPotes();
      return;
    }
    const atual = this.saborAtual();
    const esc = (s) => s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    caixa.innerHTML = Array.from({ length: n }, (_, i) => `
      <label class="body-pote">Pote ${i + 1}
        <select data-body-pote="${i + 1}">
          ${sabores.map((s) => `<option value="${esc(s.valor)}"${s.esgotado ? ' disabled' : ''}${s.valor === atual ? ' selected' : ''}>${esc(s.valor)}${s.esgotado ? ' (esgotado)' : ''}</option>`).join('')}
        </select>
      </label>`).join('');
    caixa.hidden = false;
    this.gravarPotes();
  }

  gravarPotes() {
    const form = this.form;
    if (!form) return;
    form.querySelector('input[name="properties[Sabores]"]')?.remove();
    const sels = [...this.querySelectorAll('select[data-body-pote]')];
    if (!sels.length) return;
    const campo = document.createElement('input');
    campo.type = 'hidden';
    campo.name = 'properties[Sabores]';
    campo.value = sels.map((s) => s.value).join(', ');
    form.append(campo);
    // A variante do kit segue o sabor do pote 1.
    const vs = JSON.parse(this.escolhido.querySelector('[data-body-kit-variantes]').textContent);
    const v = vs.find((x) => x.sabor === sels[0].value.trim().toLowerCase() && x.available);
    if (v && this.idInput) this.idInput.value = v.id;
  }
}
if (!customElements.get('body-kits')) customElements.define('body-kits', BodyKits);

// Landing (sections/body-landing.liquid e body-landing-duvidas.liquid): "Comprar agora" leva de
// volta à compra, no topo da página.
document.addEventListener('click', (e) => {
  const a = e.target.closest('[data-lp-comprar]');
  const alvo = a && document.querySelector('.product-information');
  if (!alvo) return;
  e.preventDefault();
  alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// Tabela nutricional longa (landing e landing automática): recolhida, com "Ver tabela completa", como na VPR.
document.querySelectorAll('.lp-nutri__corpo').forEach((corpo) => {
  if (corpo.scrollHeight <= 600) return;
  corpo.classList.add('is-recolhida');
  const b = Object.assign(document.createElement('button'), { type: 'button', className: 'lp-nutri__mais', textContent: 'Ver tabela completa' });
  b.setAttribute('aria-expanded', 'false');
  b.addEventListener('click', () => {
    const aberta = !corpo.classList.toggle('is-recolhida');
    b.setAttribute('aria-expanded', String(aberta));
    b.textContent = aberta ? 'Recolher tabela' : 'Ver tabela completa';
  });
  corpo.after(b);
});

// Frete por CEP (blocks/body-frete-cep.liquid): consulta a cidade no ViaCEP só quando a pessoa clica.
(() => {
  const sem = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  const real = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: Number(v) % 1 ? 2 : 0 });
  const dias = (n) => (Number(n) === 1 ? '1 dia útil' : `${n} dias úteis`);
  document.querySelectorAll('[data-body-frete]').forEach((caixa) => {
    if (caixa.dataset.ligado) return;
    caixa.dataset.ligado = '1';
    let cidades = [];
    try { cidades = JSON.parse(caixa.querySelector('[data-body-frete-cidades]').textContent); } catch { cidades = []; }
    const input = caixa.querySelector('input');
    const saida = caixa.querySelector('[data-body-frete-resultado]');
    const preco = Number(caixa.dataset.preco || 0);
    const politica = caixa.dataset.politica;
    try { const salvo = localStorage.getItem('body-cep'); if (salvo) input.value = salvo; } catch { /* sem armazenamento */ }
    input.addEventListener('input', () => {
      const d = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
    });
    const mostrar = (html) => { saida.innerHTML = html; };
    caixa.querySelector('form').addEventListener('submit', async (e) => {
      e.preventDefault();
      const cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) return mostrar('Digite um CEP com 8 números.');
      mostrar('Consultando…');
      let end;
      try {
        end = await (await fetch(`https://viacep.com.br/ws/${cep}/json/`)).json();
      } catch {
        return mostrar('Não conseguimos consultar o CEP agora. O frete aparece no checkout.');
      }
      if (!end || end.erro) return mostrar('CEP não encontrado. Confira os números.');
      try { localStorage.setItem('body-cep', input.value); } catch { /* sem armazenamento */ }
      const lugar = `<b>${end.localidade}/${end.uf}</b>`;
      const rr = end.uf === 'BA' && cidades.find((c) => sem(c.c) === sem(end.localidade));
      const link = politica ? ` <a href="${politica}">Ver a política</a>` : '';
      // Guarda a região do cliente para o carrinho mostrar a barra de frete grátis certa (assets/body-carrinho.js).
      try { localStorage.setItem('body-frete-zona', rr ? 'rr' : end.uf === 'BA' ? 'ba' : 'fora'); } catch { /* sem armazenamento */ }
      if (rr) {
        const lim = Number(caixa.dataset.limiteRr);
        const ja = preco >= lim ? ' Este produto já tem frete grátis.' : '';
        // A tabela nova da Yampi traz só o prazo; a frequência (diário, ter/qui/sáb) fica opcional.
        const f = (rr.f || '').trim();
        const freq = !f || f === '-' ? '' : /di[aá]rio/i.test(f) ? ' (entregas diárias)' : ` (entregas ${f})`;
        return mostrar(`${lugar}: frete grátis acima de ${real(lim)} pela RR Transportes. Entrega em ${dias(rr.p)}${freq}.${ja}${link}`);
      }
      if (end.uf === 'BA') {
        const lim = Number(caixa.dataset.limiteBa);
        const ja = preco >= lim ? ' Este produto já tem frete grátis.' : '';
        return mostrar(`${lugar}: frete grátis acima de ${real(lim)} por SEDEX, com entrega em até ${dias(caixa.dataset.prazoBa)}.${ja}${link}`);
      }
      return mostrar(`${lugar}: o valor e o prazo do frete aparecem no checkout.`);
    });
  });
})();
